import { render, staticRenderFns } from "./AddOrRemoveMaintenance.vue?vue&type=template&id=4888a586&scoped=true&"
import script from "./AddOrRemoveMaintenance.vue?vue&type=script&lang=js&"
export * from "./AddOrRemoveMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./AddOrRemoveMaintenance.vue?vue&type=style&index=0&id=4888a586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888a586",
  null
  
)

export default component.exports